// extracted by mini-css-extract-plugin
export var rateTable = "_65-0";